var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPortal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedPortal0)",
    fillRule: "evenodd",
    d: "M18.428 8.143L12 4.286L5.57 8.143v7.714L12 19.714l6.428-3.857zm-9-.572v8.901l2.144-.992v-5.037l1.285-1.048v4.228l-1.259.955L15 16.472v-5.938l-2.143-1.142v.003z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedPortal0",
    x1: 8.245,
    x2: 19.337,
    y1: 13.344,
    y2: 16.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#064FAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#180043"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortal);
export default __webpack_public_path__ + "static/media/portal.1c2efadecc184ff3b25ae08ca90f8565.svg";
export { ForwardRef as ReactComponent };